import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MyPageHome from './MyPageHome';
import MyPageClassroom from './MyPageClassroom';
import MyPageCertificate from './MyPageCertificate';
import MyPageBookmark from './MyPageBookmark';
import MyPageActivity from './MyPageActivity';
import MyPageSettings from './MyPageSettings';
import MyPageProfileEdit from './MyPageProfileEdit';
import MyPageInquiry from './MyPageInquiry';

const MyPageIndex: React.FC = () => {
  return (
    <Routes>
      <Route index element={<MyPageHome />} />
      <Route path="my-classroom" element={<MyPageClassroom />} />
      <Route path="certificate" element={<MyPageCertificate />} />
      <Route path="bookmark" element={<MyPageBookmark />} />
      <Route path="activity" element={<MyPageActivity />} />
      <Route path="profile-edit" element={<MyPageProfileEdit />} />
      <Route path="inquiry" element={<MyPageInquiry />} />
      <Route path="settings" element={<MyPageSettings />} />
    </Routes>
  );
};

export default MyPageIndex;
